import React, { useEffect, useState } from 'react'
import {
    Cascader,
    Space,
    Skeleton,
    Input,
    Divider,
    Radio,
} from 'antd';
import "./index.scss";
import { hall } from '../../service'
import provinces from "china-division/dist/provinces";
import cities from "china-division/dist/cities";
import areas from "china-division/dist/areas";
import dayjs from 'dayjs'

export default function CategorySearch({ queryParams, onChangeParams }) {
    const [classifyOne, setClassifyOne] = useState([])
        , [classifyTwo, setClassifyTwo] = useState([])
        , [classifyThree, setClassifyThree] = useState([])
        , [newParams, setNewParams] = useState(queryParams)

    useEffect(() => {
        async function fetchData() {
            const { data } = await hall.apiClassify.getClassify(0, 0)
            setClassifyOne(data)
        }
        fetchData()
    }, [])

    // 监听newParams的变化
    useEffect(() => {
        onChangeParams(newParams);
    }, [newParams, onChangeParams]);

    const options = provinces.map((province) => ({ ...province, children: cities.filter(citie => province.code === citie.provinceCode).map(citie => ({ ...citie, children: areas.filter(area => area.cityCode === citie.code) })) }))

    // 一级分类筛选
    const onChangeOne = async (value) => {
        const { data } = await hall.apiClassify.getClassify(value, 1)
        if (data && data.length) {
            setClassifyTwo(data)
            setClassifyThree([])
            updateParams({ classify: value, level: 0 })
        } else {
            setClassifyTwo([])
            setClassifyThree([])
            updateParams({ classify: null, level: 0 })
        }
    }

    // 二级分类筛选
    const onChangeTwo = async (value) => {
        const { data } = await hall.apiClassify.getClassify(value, 2)
        if (data && data.length) {
            setClassifyThree(data)
            updateParams({ classify: value, level: 1 })
        } else {
            setClassifyThree([])
            updateParams({ classify: value, level: 0 })
        }
    }

    // 三级分类筛选
    const onChangeThree = async (value) => {
        const idx = classifyTwo.findIndex(item => item.id === value)
        if (idx === 1) {
            updateParams({ classify: value, level: 1 })
        } else {
            updateParams({ classify: value, level: 2 })
        }
    }

    // 更新搜索参数
    const updateParams = (params) => {
        setNewParams(prevState => {
            const newState = { ...prevState, ...params }
            return newState;
        });
    }

    // 时间范围选择
    const onChangeDate = (value) => {
        updateParams({ startTime: value })
    }

    // 选择省市区
    const onCascaderChange = (province, city, town) => {
        updateParams({ province, city, town })
    }

    // 输入框搜索查询
    const onInputSearch = (value) => {
        updateParams({ search: value })
    }

    return (
        <div className='classify-search-container'>

            <div className='option'>
                <div className='custom-label'>
                    全部：
                </div>
                <div className='custom-radios'>
                    {
                        classifyOne.length ? (
                            <Radio.Group
                                optionType="button"
                                buttonStyle="solid"
                                defaultValue={-1}
                                onChange={({ target: { value } }) => onChangeOne(value)}
                            >
                                {
                                    classifyOne.map((item) => (
                                        <Radio.Button key={item.name} value={item.id} className='custom-button'>{item.name}</Radio.Button>
                                    ))
                                }

                            </Radio.Group>
                        ) : (<Skeleton />)
                    }

                </div>
            </div>

            {
                classifyTwo && classifyTwo.length ? (
                    <div className='option'>
                        <div className='custom-label'>
                            作业品种：
                        </div>
                        <div className='custom-radios'>
                            <Radio.Group
                                optionType="button"
                                buttonStyle="solid"
                                onChange={({ target: { value } }) => onChangeTwo(value)}
                            >

                                {
                                    classifyTwo.map((item) => (
                                        <Radio.Button key={item.name} value={item.id} className='custom-button'>{item.name}</Radio.Button>
                                    ))
                                }

                            </Radio.Group>
                        </div>
                    </div>
                ) : (null)
            }

            {
                classifyThree && classifyThree.length ? (
                    <div className='option'>
                        <div className='custom-label'>
                            作业类型：
                        </div>
                        <div className='custom-radios'>
                            <Radio.Group
                                optionType="button"
                                buttonStyle="solid"
                                onChange={({ target: { value } }) => onChangeThree(value)}
                            >

                                {
                                    classifyThree.map((item) => (
                                        <Radio.Button key={item.name} value={item.id} className='custom-button'>{item.name}</Radio.Button>
                                    ))
                                }

                            </Radio.Group>
                        </div>
                    </div>
                ) : (null)
            }



            <div className='option'>
                <div className='custom-label'>
                    发布时间：
                </div>
                <div className='custom-radios'>
                    <Radio.Group
                        optionType="button"
                        buttonStyle="solid"
                        defaultValue={-1}
                        onChange={({ target: { value } }) => onChangeDate(value)}
                    >
                        <Radio.Button value={-1} className='custom-button'>不限</Radio.Button>
                        <Radio.Button value={dayjs().add(-1, 'd').format("YYYY-MM-DD")} className='custom-button'>近1天</Radio.Button>
                        <Radio.Button value={dayjs().add(-7, 'd').format("YYYY-MM-DD")} className='custom-button'>近7天</Radio.Button>
                        <Radio.Button value={dayjs().add(-30, 'd').format("YYYY-MM-DD")} className='custom-button'>近一个月</Radio.Button>
                        <Radio.Button value={dayjs().add(-90, 'd').format("YYYY-MM-DD")} className='custom-button'>近三个月</Radio.Button>

                    </Radio.Group>
                </div>
            </div>


            <Divider style={{ margin: '5px  0 15px' }} />

            <div className='option' style={{ padding: '0 40px' }}>
                {/* <div>
                    <Radio.Group
                        optionType="button"
                        buttonStyle="solid"
                        size='middle'
                    >
                        <Radio.Button value="option0">最热</Radio.Button>
                        <Radio.Button value="option1">最新</Radio.Button>
                        <Radio.Button value="option2">最近</Radio.Button>
                        <Radio.Button value="option3">最好评</Radio.Button>
                    </Radio.Group>
                </div> */}

                <Space>
                    {/* <div>地址：</div>
                    <Cascader
                        style={{ width: '300px' }}
                        placeholder='请选择省市区'
                        options={options}
                        fieldNames={{ label: 'name', value: 'name' }}
                        defaultValue={['安徽省']}
                        onChange={value => {
                            if (value) {
                                const [province, city, town] = value
                                onCascaderChange(province, city, town);
                            } else {
                                updateParams({ province: null, city: null, town: null })
                            }
                        }}
                    /> */}

                    <Input.Search
                        style={{ width: '300px' }}
                        className='search'
                        placeholder="请输入名称/地址"
                        allowClear
                        enterButton="搜索"
                        onSearch={onInputSearch}
                    />
                </Space>

            </div>

        </div>
    )
}
